// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-15n67";
var _4 = "group-1OgBG";
var _5 = "items-3RmzX";
var _6 = "dateSeparator-1kYQs";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "group", _5 as "items", _6 as "dateSeparator" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "group": _4, "items": _5, "dateSeparator": _6 }
